<div class="progress-container mt-4">
  <div class="step-wrapper">
    <div class="step"><img class="active-img bg-orange"  src="assets/img/image_1.png" alt="Step 1"></div>
    <div class="label">File Validation</div>
  </div>
  <div class="line half-filled"></div>
  <div class="step-wrapper">
    <div class="step"><img class="active-img bg-grey" src="assets/img/image_2.png" alt="Step 2"></div>
    <div class="label">Board Details</div>
  </div>
  <div class="line"></div>
  <div class="step-wrapper">
    <div class="step"><img class="active-img bg-grey" src="assets/img/image_3.png" alt="Step 3"></div>
    <div class="label">Quote</div>
  </div>
  <div class="line"></div>
  <div class="step-wrapper">
    <div class="step"><img class="active-img bg-grey" src="assets/img/image_4.png" alt="Step 3"></div>
    <div class="label">Order Details</div>
  </div>
  <div class="line"></div>
  <div class="step-wrapper">
    <div class="step"><img  class="active-img bg-grey" src="assets/img/image_5.png" alt="Step 3"></div>
    <div class="label">Review & Confirm</div>
  </div>
  <div class="line"></div>
  <div class="step-wrapper">
    <div class="step"><img class="active-img bg-grey" src="assets/img/image_6.png" alt="Step 3"></div>
    <div class="label">Place order</div>
  </div>
</div>

<div class="page_bottom_space" style="min-height:385px">
    <div *ngIf="!validationCheck" class="p-4">
      <div class="fs-5 text-center fw-b p-1 bg-grey">Design File Details</div>

      <div class="mt-2 mb-2 fw-bolder" *ngIf="commonService.commonMainObj.uploadedFilesData?.fileWarnings && commonService.commonMainObj.uploadedFilesData?.fileErrors.length>0 && !this.moreFileFormatError">
        <p class="text-danger mb-2">Please fix all errors and re-upload files to get a quote</p>
      </div>

        <div class="" *ngIf="commonService.commonMainObj.uploadedFilesData?.fileErrors?.length>0 && !fileFormatError && !this.moreFileFormatError">
            <div class="p-2 file-errors fw-b">Errors: <p style="font-style: italic;margin-bottom: 0;font-size: 14px;">Click over the info icon <span class="fa fa-info-circle"></span> next to each error for additional details</p> </div>
            <div class="brd_danger">
                <ul class="list-type-number">
                    <li *ngFor="let errData of commonService.commonMainObj.uploadedFilesData?.fileErrors; let indx = index">{{errData.error}} 
                      <div class="ofp-tooltip">
                        <span class="fa fa-info-circle" (mouseover)="showToolTip(errData.description,indx+1)" (mouseout)="hideToolTip(errData.description,indx+1)"></span>
                        <span class="tooltiptext" id="infoIcon-{{indx+1}}"></span>
                      </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="mt-3" *ngIf="commonService.commonMainObj.uploadedFilesData?.fileWarnings && !this.moreFileFormatError">
          
          <div class=" text-center mt-3" style="font-size: 0.9rem;" *ngIf="commonService.commonMainObj.uploadedFilesData?.fileWarnings && commonService.commonMainObj.uploadedFilesData?.fileErrors?.length==0"><b class="text_warning" style="font-style: italic;">We found few discrepancies/missing files in the design package.</b><br/>
            <div style="padding-top: 5px; padding-bottom: 5px;">You have the option to address the warnings right away by making required changes and re-launching Sierra plugin from KiCad tool, or you can continue with your current files to receive a quote and place an order.<br/>If you choose to proceed without fixing the warnings, you can rectify them later by through the portal by accessing your order.<br/></div>
            <div class="text_warning" style="font-style: italic;"><b>NOTE: If you decide to address the warnings after placing an order, the final quote may be subject to change.</b> </div>
          </div>
           <div class="table-row">
            <table class="table warning-table mt-4" style="width: 100%; word-break: break-word;">
              <thead>
                <tr>
                  <th style="width: 50%;text-align:center; font-size: 1rem;">Warning</th>
                  <th style="width: 50%;text-align:center; font-size: 1rem;">Additional Information</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let warData of commonService.commonMainObj.uploadedFilesData?.fileWarnings; let in = index">
                  <td class="fw-b bg-pink" style="width: 50%;vertical-align: top;"><span style="font-size: 1rem;font-weight: 500;">{{warData.warning}}</span></td>
                  <td style="width: 50%;">{{warData.description}}</td>
                </tr>
              </tbody>
            </table>
           </div>
          

        </div>
        <div class="text-center text-danger mt-5 mb-3 fw-bolder" *ngIf="commonService.commonMainObj.uploadedFilesData?.fileErrors?.length>0 &&  !commonService.commonMainObj.uploadedFilesData?.fileWarnings && !fileFormatError">Please fix all errors and re-upload files to get a quote</div>
        <div class="mt-5 mb-3" *ngIf="commonService.commonMainObj.uploadedFilesData?.fileErrors?.length==0"><b>Design Package Preview:</b> </div>
        <div *ngIf="commonService.commonMainObj.uploadedFilesData?.fileErrors?.length==0">
            <form name="fileForm">
                <div style="display: flex;">
                    <div class="pe-xl-4">
                        <label for="designer-package-name">Design Package Name <span class="text-danger">*</span></label>
                        <br />
                        <input id="designer-package-name" #designFName class="form-control" type="text" [(ngModel)]="this.designPackageName" (keyup)="fileNameChange($event)" name="fileName" title="{{designPackageName}}"/>
                    </div>
                    <div class="pe-xl-4">
                        <label for="part-number">Part Number <span class="text-danger">*</span></label>
                        <br />
                        <input id="part-number" #partNum class="form-control" type="text" [(ngModel)]="commonService.commonMainObj.uploadedFilesData.partNumber" name="partNumber" (keyup)="commonService.removeRedBorder('part-number')">
                    </div>
                    <div class="pe-xl-4">
                        <label for="part-revision">Revision <span class="text-danger">*</span></label>
                        <br />
                        <input id="part-revision" #partRevision class="form-control" type="text" [(ngModel)]="commonService.commonMainObj.uploadedFilesData.partRevision"  name="partRevision" (keyup)="commonService.removeRedBorder('part-revision')">
                    </div>
                </div>
              </form>
        </div>
        <div>
          <div class="bom-table" style="width:100% !important;display: block;" *ngIf="commonService.commonMainObj.uploadedFilesData?.fileErrors?.length==0">
            <div class="table-row mt-5" id="bom-table-id">
              <table class="table">
                <thead>
                  <tr>
                    <th>Serial Number</th>
                    <th>File Name</th>
                    <th>File Type</th>
                    <th>File Format </th>
                    <th>File Size</th>
                    <th>File Last Modified</th>
                  </tr>
                </thead>
                <tbody *ngIf="commonService.commonMainObj?.uploadedFilesData?.directoryList">
                  <tr *ngFor="let lit of commonService.commonMainObj.listOfAllFiles; let ind = index">
                    <td>{{ind + 1}}</td>
                    <td>{{lit.name}}</td>
                    <td>{{lit.type}}</td>
                    <td>{{lit.mainFileType}}</td>
                    <td>{{lit.fileDetails.fileSize}}</td>
                    <td>{{lit.fileDetails.modifiedDate}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="text-center mt-4" [ngClass]="this.moreFileFormatError ? 'extra-mt' : ''">
            <button type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5  m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" *ngIf="commonService.commonMainObj.uploadedFilesData?.fileErrors?.length==0" (click)="proceedToBoardsDetails()"> <b>Continue</b>
            </button>
          </div>
        </div>
    </div>
</div>

<div *ngIf="commonService.commonMainObj.uploadedFilesData?.fileErrors?.length==0 && !commonService.commonMainObj.uploadedFilesData?.fileWarnings" style="display: none;" id="errorFreeFile-wrx4"></div>
<app-footer></app-footer>